import { Component,  Input, ViewChild } from '@angular/core';

@Component({
  selector: 'video-player',
  templateUrl: 'video-player.html'
})
export class VideoPlayerComponent {

  @Input() src: string;
  //@Input() poster: string
  @ViewChild('player') player;

  constructor() {}

  ngOnDestroy() {
    this.player.nativeElement.src = '';
    this.player.nativeElement.load();
    console.log("Destroy")
  }


}



// WEBPACK FOOTER //
// ./src/components/video-player/video-player.ts